import React, { useState } from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import { MarsModal, MarsButton } from 'src/skins/mars/components/common';
import { DashboardLayout } from 'src/skins/mars/components/layouts';
import { RadioInput, PhotoUpload } from 'src/skins/mars/components/inputs';

const Wrapper = styled.div`
  margin-bottom: 3.5rem;

  .mb-5 {
    margin-bottom: 5px;
  }
`;

export const IdVerification = () => {
  const history = useHistory();

  const agentIdentificationOptions = [
    { value: 'driversLicense', label: 'Driver\'s License' },
    { value: 'nin', label: 'NIN' },
    { value: 'internationalPassport', label: 'International Passport' },
  ];
  const [agentIdentification, setAgentIdentification] = useState(agentIdentificationOptions[0].value);

  const [idImages, setIdImages] = useState(null);
  const [utilityBill, setUtilityBill] = useState(null);

  const handleSubmit = e => {
    e.preventDefault();
    const formData = new FormData(e.target);
    // eslint-disable-next-line no-console
    console.log('submitted form data: ', Object.fromEntries(formData));
  };

  return (
    <DashboardLayout light>
      <MarsModal
        isOpen={true}
        closeModal={() => history.replace('/dashboard/settings/profile')}
        fullheight={true}
        backgroundPage="settings"
      >
        <Wrapper>
          <h4 className="mb-5">ID Verification</h4>

          <form onSubmit={handleSubmit} autoComplete="off">
            <p className="mb-5">Proof of Identification</p>
            <br />
            <RadioInput
              options={agentIdentificationOptions}
              value={agentIdentification}
              onChange={setAgentIdentification}
              name="proofOfId"
            />
            <br />
            <PhotoUpload
              name="idImage"
              files={idImages}
              onChange={e => setIdImages(e.target.files)}
              placeholder="Upload ID"
            />
            <br />
            <br />
            <p className="mb-5">Proof of Address</p>
            <br />
            <PhotoUpload
              name="utilityBill"
              files={utilityBill}
              onChange={e => setUtilityBill(e.target.files)}
              placeholder="Upload Utility Bill"
            />
            <br />
            <br />
            <MarsButton type="submit" text="Submit" size="large" />
          </form>
        </Wrapper>
      </MarsModal>
    </DashboardLayout>
  );
};

export default IdVerification;
